import { Injectable } from '@angular/core';
import { L10n, Wrapper } from '@skylab-angular-shared/core';
import { PrintingPatternConfigBase } from '@skylab-shared/business';
export { PrintingPatternConfigBase };

@Injectable({ providedIn: 'root'})
@Wrapper(PrintingPatternConfigBase)
export class PrintingPatternConfig {
    public constructor (
        l10n: L10n
    ) {}
}
